import React from 'react';
import styles from './onestop.module.css';
import basestyles from '../../styles/basestyles.module.css';

function Onestop() {
  return (
    <div className={styles.onestop}>
      <div className={basestyles.maxWidth}>
      <div className={styles.useflex}>
      <h2>One-Stop Place for Consumers, Farmers and Retailers.</h2>
      <img src="Vegetable.jpg" alt="vegetable" className={styles.basket}/>
      </div>
      <p>
        "Adaya is a growing business model by Adaya Pvt Ltd" with an aim of delivering 100% fresh fruits, vegetables and food grains to the customer's place directly from the farmers across Karnataka. Thus, eliminating the middleman costs and serving as the one-stop platform that increasingly benefits  farmers,retailers and consumers at one go. 
      </p>
      </div>
      
    </div>
  );
}

export default Onestop;